import { render, staticRenderFns } from "./reauth-market-modal.vue?vue&type=template&id=c030a67a&scoped=true&"
import script from "./reauth-market-modal.vue?vue&type=script&lang=js&"
export * from "./reauth-market-modal.vue?vue&type=script&lang=js&"
import style0 from "./reauth-market-modal.vue?vue&type=style&index=0&id=c030a67a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c030a67a",
  null
  
)

export default component.exports